export default "__VITE_ASSET__Fg9yo34Q__"